import React from 'react';
import ReactTable from 'react-table'
import '../../node_modules/react-table/react-table.css'

const propTypes = {
  
};

const Table = (props) => {
  return (
    <ReactTable 
    className='-striped'
    stripedColor="#00c7a5"
    highlightColor="#00c7a5"
    {...props} />
  );
};


Table.propTypes = propTypes;


export default Table;